import * as React from "react";

import ImgBgDecoration from "@assets/images/overview-header-decoration.png";
import { HeaderContentComponent } from "@app/core/header-content";
import { MediumHeroModule } from "@app/api/modules/medium-hero/medium-hero";
import { USP } from "@app/core";

import styles from "./medium-hero-component.module.scss";

export interface IMediumHeroComponentProps {
  mediumHeroModule: MediumHeroModule;
}

const MediumHeroComponent = (props: IMediumHeroComponentProps) => {
  const { usps, headerContent } = props.mediumHeroModule;

  return (
    <div className={styles["medium-hero"]}>
      <div className="uk-container">
        <div className={styles.top}>
          <USP uspModule={usps} defaultIcons />
        </div>
        <div className={styles.holder}>
          <div className={styles.image}>
            <img className={styles.bgDecoration} src={ImgBgDecoration} />
          </div>

          {headerContent && (
            <div className={styles.content}>
              <HeaderContentComponent
                title={headerContent.title}
                subtitle={headerContent.subtitle}
                text={headerContent.text}
                breadcrumbProps={headerContent.breadcrumbProps}
                headerMobilePosition="center"
                useDarkText
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export { MediumHeroComponent };
